import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useEmployeeService } from 'domain/shared/employee';

const PERFORMANCE_MEASUREMENT_CONTEXT = 'EmployeeStretchGoal';

const PerformanceMeasurementContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getGlobalPeopleManagementPermissions } = useEmployeeService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getGlobalPeopleManagementPermissions}
      permissionToCheck={permissionToCheck}
      contextName={PERFORMANCE_MEASUREMENT_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default PerformanceMeasurementContext;
